module.exports = __webpack_public_path__ + "img/tooths.fcfcf802.png";